import React from 'react';
import TopPanel from './TopPanel';

class Home extends React.Component {
    render() {
        return (
            <div>
                <TopPanel />
                {this.props.children}
            </div>
        );
    }
}

export default Home;